module.exports = __webpack_public_path__ + "static/media/assessmentPage.d41d8cd9.scss";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Singleassessment/assessmentPage.scss
// module id = 1978
// module chunks = 0